//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../no/Builder.js";
let d=[[[0,"Associative",1,0],[0,"CopyResolveGeometry",1,0],[0,"ExpressionOption",1,0],[0,"ParentOption",1,1],[0,"SelectOption",1,0]],[[[],"GetFeatureReferences",{R_:{feature_references_data:"Features.FeatureReferencesBuilder"}},0,0],[[],"UpdateBuilder",{},0,0],[[],"GetBuilderVersion",{R_:{version:''}},0,0],[["version"],"SetBuilderVersion",{},1,0]],[]];
SPLM.Features.CopyPasteBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.CopyPasteBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.CopyPasteBuilder.BuilderVersion = Object.freeze({
    "Original" : "Original", "ExposeOnflySo" : "ExposeOnflySo", "ExposeBody" : "ExposeBody", "ShowParentSelectOption" : "ShowParentSelectOption"});

SPLM.Features.CopyPasteBuilder.ExpressionTransferOption = Object.freeze({
    "CreateNew" : "CreateNew", "LinkToOriginal" : "LinkToOriginal", "OriginalInstance" : "OriginalInstance"});

SPLM.Features.CopyPasteBuilder.ParentTransferOption = Object.freeze({
    "PromptForNew" : "PromptForNew", "CopyOriginalCurve" : "CopyOriginalCurve", "OriginalInstance" : "OriginalInstance"});

SPLM.Features.CopyPasteBuilder.ParentSelectOption = Object.freeze({
    "SmartObject" : "SmartObject", "InputForOriginalParent" : "InputForOriginalParent"});

export default SPLM;